import Link from "next/link";

import { Button } from "@/components/ui/button";

import { typeCriteria } from "@/constants";

import states from "@/static/states.json";

interface Props {
  cities: string[];
  uf: string;
}

const getState = (uf: string) => states.find((state) => state.value === uf);

const City = ({ cities, uf }: Props) => (
  <>
    {cities.length > 0 ? <span> em {cities.join(", ")}</span> : null}
    <span>
      {cities.length > 0 ? `, ` : ` em `}
      {uf}
    </span>
  </>
);

export const ListInfo = (props: Props) => {
  const state = getState(props.uf);
  const propsWithState = {
    ...props,
    uf: state?.label || props.uf,
  };

  return (
    <section
      id="informação-lista-leilao-de-imoveis-cta"
      style={{
        background:
          "linear-gradient(180deg, rgba(236,233,231,1) 10%, rgba(251,250,250,1) 90%)",
      }}
      className="rounded-[40px] sm:rounded-[60px] w-full md:w-[1200px] mx-auto"
    >
      <div className="flex flex-col items-center justify-center py-20 px-5 sm:px-16 gap-16">
        <div className="flex flex-col gap-4">
          <p className="text-2xl font-semibold text-center w-full">
            Seja o primeiro! Receba as melhores oportunidades de{" "}
            <strong>leilão de imóveis</strong> <City {...propsWithState} />
          </p>
          <p className="text-lg text-center text-muted-foreground w-full">
            <Link href="/sign-up/" target="_blank" className="hover:underline">
              Cadastre-se
            </Link>{" "}
            e seja notificado sobre novos <strong>leilão de imóveis</strong>{" "}
            disponíveis <City {...propsWithState} />. Os{" "}
            <strong>leilões de imóveis</strong> são uma excelente oportunidade
            para quem deseja investir com segurança e boa rentabilidade, ou para
            quem busca adquirir um <strong>imóvel com desconto</strong> para uso
            próprio. Nossa equipe de especialistas está pronta para te ajudar em
            todo o processo.
          </p>
        </div>
        <div className="flex flex-col gap-4">
          <p>
            O Pro Leilão reúne os melhores <strong>imóveis em leilão</strong> de
            diversas modalidades <City {...propsWithState} />. São imóveis
            oferecidos por meio de <strong>Venda Direta</strong>,{" "}
            <strong>Leilão Judicial</strong> e{" "}
            <strong>Leilão Extrajudicial</strong>. Atualmente, temos disponíveis
            para você leilão de imóveis em <City {...propsWithState} />,
            divididos em:
          </p>
          <ul className="list-disc pl-8 flex flex-col gap-2">
            <li>
              Imóveis Caixa Econômica Federal (CEF) <City {...propsWithState} />
            </li>
            <li>
              Imóveis Santander <City {...propsWithState} />
            </li>
            <li>
              Imóveis Bradesco <City {...propsWithState} />
            </li>
            <li>
              Leilão de imóveis extrajudicial <City {...propsWithState} />
            </li>
            <li>
              Leilão de imóveis Venda Direta Online <City {...propsWithState} />
            </li>
            <li>
              Leilão de imóveis Leilão SFI - Edital Único{" "}
              <City {...propsWithState} />
            </li>
            <li>
              Leilão de imóveis Licitação Aberta <City {...propsWithState} />
            </li>
            <li>
              Leilão de imóveis Venda Online <City {...propsWithState} />
            </li>
          </ul>
          <ul className="list-disc pl-8 flex flex-col gap-2">
            <li>
              {typeCriteria.casa} <City {...propsWithState} />
            </li>
            <li>
              {typeCriteria.apartamento} <City {...propsWithState} />
            </li>
            <li>
              {typeCriteria.terreno} <City {...propsWithState} />
            </li>
            <li>
              {typeCriteria.sala} <City {...propsWithState} />
            </li>
            <li>
              {typeCriteria.comercial} <City {...propsWithState} />
            </li>
            <li>
              {typeCriteria.galpão} <City {...propsWithState} />
            </li>
            <li>
              {typeCriteria.loja} <City {...propsWithState} />
            </li>
            <li>
              {typeCriteria.predio} <City {...propsWithState} />
            </li>
            <li>
              {typeCriteria.lote} <City {...propsWithState} />
            </li>
            <li>
              {typeCriteria.gleba} <City {...propsWithState} />
            </li>
          </ul>
        </div>
        <div className="flex flex-col gap-4">
          <p className="font-semibold">
            Imóveis Caixa <City {...propsWithState} />
          </p>
          <p>
            No universo dos leilões de imóveis, os imóveis Caixa são os mais
            seguros para aquisição. O banco disponibiliza apenas imóveis que,
            após uma rigorosa análise jurídica, são considerados livres de
            riscos judiciais, mesmo aqueles com processos em andamento. A
            maioria desses imóveis pode ser financiada com apenas 5% de entrada,
            e o FGTS pode ser utilizado para o pagamento. Essa modalidade de
            leilão tem amplo respaldo legal, sendo amplamente reconhecida e
            compreendida pelos tribunais, especialmente por conta da Lei de
            Alienação Fiduciária.
          </p>
        </div>
        <div className="flex flex-col gap-4">
          <p className="font-semibold">
            Leilão Extrajudicial de Imóveis <City {...propsWithState} />
          </p>
          <p>
            A Lei de Alienação Fiduciária transformou o mercado imobiliário,
            tornando o financiamento imobiliário mais acessível e com taxas de
            juros reduzidas. Essa lei permite que imóveis usados como garantia
            de empréstimos, especialmente os financiamentos imobiliários, possam
            ser retomados pelos bancos de forma mais rápida e sem a necessidade
            de longos e caros processos judiciais. Com isso, os custos para os
            bancos diminuem, o que resulta na redução das taxas de juros e
            facilita o acesso ao crédito.
          </p>
          <p>
            Quando o tomador do empréstimo não paga as parcelas, o banco pode
            retomar o imóvel e colocá-lo em leilão extrajudicial para quitar a
            dívida. Essa modalidade oferece um risco intermediário, mas traz
            excelentes oportunidades de aquisição. O Pro Leilão realiza
            diariamente uma busca pelos melhores leilão de imóveis dos
            principais bancos, simplificando a procura por boas oportunidades e
            economizando o seu tempo.
          </p>
        </div>
        <Button size="lg" className="px-6" asChild>
          <Link href="/sign-up/" target="_blank">
            Criar conta
          </Link>
        </Button>
      </div>
    </section>
  );
};
